export default __webpack_public_path__ + "static/media/Ophelia-New Photo-IMG_3280 (1).cbb16096.jpeg";